
import { useState } from 'react';

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: "Ayşe Yılmaz",
      role: "2 Çocuk Annesi",
      image:
        "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20happy%20turkish%20mother%20in%20her%2030s%20smiling%20warmly%2C%20confident%20woman%20with%20natural%20makeup%2C%20bright%20clean%20background%2C%20professional%20headshot%20photography%2C%20warm%20lighting%2C%20trustworthy%20appearance%2C%20high%20quality%20image&width=200&height=200&seq=test1&orientation=squarish",
      rating: 5,
      text: "3 yaşındaki oğlum için aldığım probiyotik takviyeden çok memnunum. Bağışıklık sistemi güçlendi ve artık daha az hastalanıyor. Organik olması benim için çok önemliydi.",
      product: "Çocuk Probiyotiği"
    },
    {
      name: "Mehmet Demir",
      role: "3 Çocuk Babası",
      image:
        "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20happy%20turkish%20father%20in%20his%2040s%20smiling%20confidently%2C%20friendly%20man%20with%20casual%20business%20attire%2C%20bright%20clean%20background%2C%20professional%20headshot%20photography%2C%20natural%20lighting%2C%20trustworthy%20appearance%2C%20high%20quality%20image&width=200&height=200&seq=test2&orientation=squarish",
      rating: 5,
      text: "Tüm aile olarak kolajen ürünlerini kullanıyoruz. 14 yaşındaki kızımın cilt sağlığı için harika. Kaliteli ve güvenilir ürünler sunduğunuz için teşekkürler.",
      product: "Aile Kolajen Paketi"
    },
    {
      name: "Zeynep Kaya",
      role: "Yeni Anne",
      image:
        "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20turkish%20mother%20in%20her%2020s%20with%20gentle%20smile%2C%20caring%20woman%20with%20natural%20beauty%2C%20bright%20clean%20background%2C%20professional%20headshot%20photography%2C%20soft%20lighting%2C%20warm%20trustworthy%20appearance%2C%20high%20quality%20image&width=200&height=200&seq=test3&orientation=squarish",
      rating: 5,
      text: "Bebeğim için D3 vitamini damlasını kullanıyorum. Pediatristim de onayladı. Doğal içeriği ve kalitesi beni çok memnun etti. Kesinlikle tavsiye ederim.",
      product: "Bebek D3 Vitamini"
    },
    {
      name: "Can Özdemir",
      role: "Sporcu Baba",
      image:
        "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20athletic%20turkish%20man%20in%20his%2030s%20smiling%20energetically%2C%20fit%20healthy%20man%20with%20sporty%20appearance%2C%20bright%20clean%20background%2C%20professional%20headshot%20photography%2C%20dynamic%20lighting%2C%20confident%20appearance%2C%20high%20quality%20image&width=200&height=200&seq=test4&orientation=squarish",
      rating: 5,
      text: "10 yaşındaki oğlum için omega-3 takviyesi alıyorum. Okul başarısı arttı ve daha konsantre. Ayrıca kendim için de kolajen kullanıyorum, harika sonuçlar!",
      product: "Omega-3 & Kolajen"
    }
  ];

  return (
    <section className="py-10 sm:py-12 md:py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Aileler Ne Diyor?
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            Binlerce mutlu ailenin deneyimlerini okuyun
          </p>
        </div>

        <div className="relative">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`bg-white p-4 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl shadow-md sm:shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer ${
                  activeIndex === index ? "ring-2 ring-brand-500" : ""
                }`}
                onClick={() => setActiveIndex(index)}
              >
                <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                  <div className="w-11 h-11 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://via.placeholder.com/200?text=No+Image";
                      }}
                    />
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 text-xs sm:text-sm md:text-base">
                      {testimonial.name}
                    </div>
                    <div className="text-[10px] sm:text-xs md:text-sm text-gray-600">
                      {testimonial.role}
                    </div>
                  </div>
                </div>

                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i
                      key={i}
                      className="ri-star-fill text-amber-400 text-xs sm:text-sm"
                    ></i>
                  ))}
                </div>

                <p className="text-gray-700 text-[11px] sm:text-xs md:text-sm leading-relaxed mb-3 sm:mb-4 line-clamp-4 sm:line-clamp-none">
                  &quot;{testimonial.text}&quot;
                </p>

                <div className="pt-3 sm:pt-4 border-t border-gray-100">
                  <div className="text-[10px] sm:text-xs text-brand-600 font-semibold">
                    <i className="ri-shopping-bag-line mr-1"></i>
                    {testimonial.product}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 sm:mt-10 md:mt-12 text-center">
          <div className="inline-flex items-center gap-4 sm:gap-6 md:gap-8 bg-white px-4 sm:px-6 md:px-8 py-3 sm:py-4 rounded-xl sm:rounded-full shadow-lg">
            <div className="text-center">
              <div className="text-xl sm:text-2xl md:text-3xl font-bold text-brand-600">
                4.9/5
              </div>
              <div className="text-[10px] sm:text-xs md:text-sm text-gray-600">
                Ortalama Puan
              </div>
            </div>
            <div className="w-px h-8 sm:h-10 md:h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-xl sm:text-2xl md:text-3xl font-bold text-brand-600">
                12,450+
              </div>
              <div className="text-[10px] sm:text-xs md:text-sm text-gray-600">
                Müşteri Yorumu
              </div>
            </div>
            <div className="w-px h-8 sm:h-10 md:h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-xl sm:text-2xl md:text-3xl font-bold text-brand-600">
                98%
              </div>
              <div className="text-[10px] sm:text-xs md:text-sm text-gray-600">
                Tavsiye Oranı
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
